import styled from 'styled-components';

import { fonts, Text } from '@dreryk/react-components';

import { PriceText } from '../../price/PriceText';

export const StyledPriceText = styled(PriceText)`
   color: ${(props) => props.theme.textBody};
`;

StyledPriceText.displayName = 'StyledPriceText';

export const StyledText = styled(Text)`
   font-weight: ${fonts.fontWeightBold};
`;

StyledText.displayName = 'StyledText';
